import { render, staticRenderFns } from "./BuyPackageOne.vue?vue&type=template&id=72be237b&scoped=true&"
import script from "./BuyPackageOne.vue?vue&type=script&lang=js&"
export * from "./BuyPackageOne.vue?vue&type=script&lang=js&"
import style0 from "./BuyPackageOne.vue?vue&type=style&index=0&id=72be237b&lang=scss&scoped=true&"
import style1 from "./BuyPackageOne.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./BuyPackageOne.vue?vue&type=style&index=2&id=72be237b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be237b",
  null
  
)

export default component.exports